const BurgerMenu = () => (
  <svg
    aria-labelledby="burger-menu-title"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="burger-menu-title">Menu</title>
    <path
      d="M2.25 18.0029H21.75"
      stroke="rgb(40, 50, 55)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 12.0029H21.75"
      stroke="rgb(40, 50, 55)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 6.00293H21.75"
      stroke="rgb(40, 50, 55)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BurgerMenu;
